import { Component, Input, OnInit } from '@angular/core';
import { openWindow } from '../../../actions/core.actions';
import { Store } from '@ngrx/store';
import { RootState } from '../../../reducers';

@Component({
  selector: 'app-path-navi-link-unit',
  templateUrl: './path-navi-link-unit.component.html',
  styleUrls: ['./path-navi-link-unit.component.scss']
})
export class PathNaviLinkUnitComponent implements OnInit {
  @Input() universityId: string;
  @Input() disabled = false;

  constructor(private store: Store<RootState>) {}
  ngOnInit() {}

  openPassnaviHaiten() {
    if (this.disabled) return;
    const univId = this.getUnivId();
    this.store.dispatch(openWindow({ url: `https://passnavi.obunsha.co.jp/univ/${univId}/subject/?utm_source=nd-univ` }));
  }

  openPassnaviHensati() {
    if (this.disabled) return;
    const univId = this.getUnivId();
    this.store.dispatch(openWindow({ url: `https://passnavi.obunsha.co.jp/univ/${univId}/difficulty/?utm_source=nd-d` }));
  }

  private getUnivId(): string {
    return this.universityId.replace('D', '');
  }
}
